exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".table-4fa2952c{width:100%}.row-192a5b02{padding:8px}.row-192a5b02 td{border-bottom:1px solid #ddd}.video-8972f56a{padding:20px}.loadMoreContainer-e4aec6f3{display:flex;justify-content:center;padding-top:10px}.moonify-d4ea3ced{display:flex;justify-content:center}dl.infoRow-98274ea4{margin:0;min-height:22px}dl.infoRow-98274ea4 dt{font-weight:bold;float:left;width:160px;overflow:hidden;text-align:right;text-overflow:ellipsis;white-space:nowrap}dl.infoRow-98274ea4 dd{margin-left:180px}\n", ""]);

// Exports
exports.locals = {
	"table": "table-4fa2952c",
	"row": "row-192a5b02",
	"video": "video-8972f56a",
	"loadMoreContainer": "loadMoreContainer-e4aec6f3",
	"moonify": "moonify-d4ea3ced",
	"infoRow": "infoRow-98274ea4"
};